"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useValueRef;

var _react = require("react");

// TODO: [P0] #4133 Don't copy.
function useValueRef(value) {
  var ref = (0, _react.useRef)();
  var readOnlyRef = (0, _react.useMemo)(function () {
    return Object.create({}, {
      current: {
        get: function get() {
          return ref.current;
        }
      }
    });
  }, []);
  ref.current = value;
  return readOnlyRef;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VWYWx1ZVJlZiIsInZhbHVlIiwicmVmIiwidXNlUmVmIiwicmVhZE9ubHlSZWYiLCJ1c2VNZW1vIiwiT2JqZWN0IiwiY3JlYXRlIiwiY3VycmVudCIsImdldCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZVZhbHVlUmVmLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIFRPRE86IFtQMF0gIzQxMzMgRG9uJ3QgY29weS5cbmltcG9ydCB7IFJlZk9iamVjdCwgdXNlTWVtbywgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VWYWx1ZVJlZjxUPih2YWx1ZTogVCk6IFJlZk9iamVjdDxUPiB7XG4gIGNvbnN0IHJlZiA9IHVzZVJlZjxUPigpO1xuICBjb25zdCByZWFkT25seVJlZiA9IHVzZU1lbW8oXG4gICAgKCkgPT5cbiAgICAgIE9iamVjdC5jcmVhdGUoXG4gICAgICAgIHt9LFxuICAgICAgICB7XG4gICAgICAgICAgY3VycmVudDoge1xuICAgICAgICAgICAgZ2V0OiAoKSA9PiByZWYuY3VycmVudFxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgKSxcbiAgICBbXVxuICApO1xuXG4gIHJlZi5jdXJyZW50ID0gdmFsdWU7XG5cbiAgcmV0dXJuIHJlYWRPbmx5UmVmO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0FBREE7QUFHZSxTQUFTQSxXQUFULENBQXdCQyxLQUF4QixFQUFnRDtFQUM3RCxJQUFNQyxHQUFHLEdBQUcsSUFBQUMsYUFBQSxHQUFaO0VBQ0EsSUFBTUMsV0FBVyxHQUFHLElBQUFDLGNBQUEsRUFDbEI7SUFBQSxPQUNFQyxNQUFNLENBQUNDLE1BQVAsQ0FDRSxFQURGLEVBRUU7TUFDRUMsT0FBTyxFQUFFO1FBQ1BDLEdBQUcsRUFBRTtVQUFBLE9BQU1QLEdBQUcsQ0FBQ00sT0FBVjtRQUFBO01BREU7SUFEWCxDQUZGLENBREY7RUFBQSxDQURrQixFQVVsQixFQVZrQixDQUFwQjtFQWFBTixHQUFHLENBQUNNLE9BQUosR0FBY1AsS0FBZDtFQUVBLE9BQU9HLFdBQVA7QUFDRCJ9